
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class DocumentStoreDialog extends SiteEntityDialog<DocumentStoreRow, any> {
        protected getFormKey() { return DocumentStoreForm.formKey; }
        protected getIdProperty() { return DocumentStoreRow.idProperty; }
        protected getLocalTextPrefix() { return DocumentStoreRow.localTextPrefix; }
        protected getNameProperty() { return DocumentStoreRow.nameProperty; }
        protected getService() { return DocumentStoreService.baseUrl; }

        protected form = new DocumentStoreForm(this.idPrefix);

        protected updateInterface() {
            super.updateInterface();

            this.cloneButton.hide();
        }
        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            // *** Create file Export Button ***
            buttons.push(
                {
                    title: Q.text("Download"),
                    icon: "fa-download",
                    cssClass: 'fileExport-button',
                    onClick: () => {

                        let ServiceEndpoint = this.getService() + "/DownloadFile";
                        Q.postToService({ service: ServiceEndpoint, request: { EntityId: this.entityId }, target: '_blank' });

                        Q.notifySuccess(Q.text("File successfully downloaded"));
                    },
                });
            return buttons;
        }
       
    }
}